module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-GabrielleLabrie-Web-640.0549e0ff.jpg";